var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdoors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.75c1.556 0 2.926 1.234 3.916 2.301.812-.416 1.872-.896 2.797-.612.693.214 1.037.866 1.037 1.561 0 2.255-1.125 4.064-2.29 5.146-1.178 1.094-2.825 1.899-4.71 2.07v4.001c1.381-2.05 5.283-5.62 7.62-3.283 1.834 1.835-.412 5.007-1.769 6.364-.937.938-3.351 2.215-4.601 2.458a11.02 11.02 0 01-4 0c-1.25-.243-3.664-1.52-4.601-2.458-1.357-1.357-3.603-4.529-1.768-6.364 2.345-2.345 6.39 1.46 7.619 3.283v-4c-1.886-.172-3.532-.977-4.71-2.071C5.375 9.064 4.25 7.255 4.25 5c0-.695.344-1.347 1.037-1.56.925-.285 1.985.195 2.797.611.99-1.067 2.36-2.301 3.916-2.301zM5.76 4.866c-.296 1.448.791 3.244 1.8 4.18 1.067.992 2.637 1.704 4.439 1.704s3.372-.712 4.44-1.703c1.008-.937 2.095-2.733 1.799-4.181-.886-.135-1.965.692-2.66 1.12-.915-1.143-1.952-2.736-3.58-2.736-1.476 0-2.766 1.722-3.578 2.736-.783-.482-1.692-1.267-2.66-1.12zm4.94 15.14c-1.74 1.74-7.75-4.27-6.01-6.011 1.741-1.741 7.752 4.27 6.01 6.01zm8.607-6.011c1.741 1.74-4.269 7.751-6.01 6.01-1.74-1.74 4.27-7.751 6.01-6.01z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoors);
export default __webpack_public_path__ + "static/media/Outdoors.ec2d3a70b4db68c628f8a9787118c694.svg";
export { ForwardRef as ReactComponent };